<template>
  <van-row class="list-cell">
    <van-col span="12">{{item.orderId}}
    </van-col>
    <van-col span=12 style="text-align: right;">
      <span style="text-align: right; color: #ffa800; font-size: 12px;">{{generateCustomizeString(item.orderStatus)}}</span>
    </van-col>
    <van-col span="18">{{item.orderCreateAt | toLocalTime}}
    </van-col>
    <van-col span="6" v-if="item.isPickUp === 1" style="text-align: right;">
      <van-tag type="primary" plain style="margin-bottom: 5px;">{{ generateCustomizeString('pickUp') }}</van-tag>
    </van-col>
    <van-col class="member-info" span="24" v-if="item.headimgurl">
      <van-col style="">
        <img height="40" width="40" v-lazy="item.headimgurl" style="padding-top: 3px; margin-left: 5px;">
      </van-col>
      <van-col style="margin-left: 10px; width: 80%;">
        <van-col span="20">
          <span>{{ generateCustomizeString('wechatName') }} {{item.wechatName}}</span>
          <span v-if="item.remark"> ({{item.remark}})</span>
        </van-col>
        <van-col span="20">{{ generateCustomizeString('phone') }} {{generateCustomizeString('none')}}
        </van-col>
      </van-col>
    </van-col>
    <van-col class="member-info" span="24" v-else>
      <van-col span="24">
        <span>{{ generateCustomizeString('wechatName') }} {{item.wechatName}}</span>
        <span v-if="item.remark"> ({{item.remark}})</span>
      </van-col>
      <van-col span="24">{{ generateCustomizeString('phone') }} {{item.customerName}}
      </van-col>
    </van-col>
    <div style="font-size: 12px; line-height: 1.2rem;">
      <van-col span="24" style="margin-top: 5px;">{{ generateCustomizeString('goodsValue') }}
        <span class="fee">{{item.amountofGoods}}</span>
      </van-col>
      <van-col span="24">{{ generateCustomizeString('shippingFee') }}
        <span class="fee">{{item.shippingFee}}</span>
      </van-col>
      <van-col span="24">{{ generateCustomizeString('totalFee') }}
        <span class="fee">{{item.totalFee}}</span>
      </van-col>
    </div>
  </van-row>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Tag } from 'vant'

export default {
  name: 'OrderListCell',
  data() {
    return {
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg'
    }
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag
  },
  methods: {
    generateCustomizeString
  },
  created: function() {
    console.log(this.item)
  }
}
</script>

<style lang="less" scoped>
.member-info {
  // margin: 0 0.5rem;
  border-radius: 3px;
  padding: 0.3rem;
  text-align: left;
  background: #f7f7f7;
  color: #3c3c3c;
}
.list-cell {
  padding: 10px 10px 5px 10px;
  line-height: 1.5rem;
  background: #fff;
  border-radius: 3px;
  margin-bottom: 0.3rem;
  border-bottom: 1px #e2e2e2 solid;
}
.fee {
  float: right;
  color: #ffa800;
  font-weight: bold;
}
</style>
